module.exports = "/_next/static/images/FrameMobile@2x-5cb4fbdbd3fb0f2fe7d8c303092edd0f.png";